export class UserPropertyCodes {
    static readonly LAST_NAME = 'lastName';
    static readonly FIRST_NAME = 'firstName';
    static readonly EMAIL = 'email';
    static readonly MOBILE_NUMBER = 'mobileNumber';
    static readonly DISPLAY_NAME = 'DisplayName';
}
